import { cx } from '@linaria/core';
import { memo, useRef } from 'react';
import { useLeaveRevision, useCurrentCourseDescriptor } from '@pm2/course-revisions';
import { Quicksearch } from '@pm2/search';
import { Tooltip, SearchIcon } from '@ui/kit';
import { toolButtonCls } from './root.tools.style.js';
import { searchToolWrapperCls, searchButtonCls } from './tool.search.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const SearchNonMemoized = ({
  enabled,
  onEnable,
  onDisable
}) => {
  const ref = useRef(null);
  const leaveRevision = useLeaveRevision(useCurrentCourseDescriptor());
  const toggle = async () => {
    if (enabled) {
      onDisable();
    } else {
      const intent = await leaveRevision();
      if (intent === "cancel") {
        return;
      }
      onEnable();
    }
  };
  return /*#__PURE__*/jsxs("div", {
    className: cx(searchToolWrapperCls),
    children: [/*#__PURE__*/jsx(Tooltip, {
      containerRef: ref,
      placement: "bottom",
      body: "S\xF8g i indholdet p\xE5 portalen",
      disabled: enabled,
      offsetPx: 0,
      ariaType: "label",
      children: ref => /*#__PURE__*/jsx("button", {
        ref: ref,
        className: cx(toolButtonCls, searchButtonCls, enabled && "enabled"),
        onClick: toggle,
        children: /*#__PURE__*/jsx(SearchIcon, {
          height: 20
        })
      })
    }), /*#__PURE__*/jsx(Quicksearch, {
      visible: enabled,
      onClose: onDisable,
      toggleRef: ref
    })]
  });
};
const Search = /*#__PURE__*/memo(SearchNonMemoized);

export { Search };
//# sourceMappingURL=tool.search.js.map
